export type PlayPauseIconProps = {
  isPlaying: boolean;
  fillColor?: string;
  size?: number;
};
export default function PausePlayIcon({
  fillColor = 'white',
  size = 48,
  isPlaying
}: PlayPauseIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={fillColor}
    >
      {isPlaying ? (
        <path d="M5 2h5v20H5V2ZM14 2h5v20h-5V2Z" />
      ) : (
        <path
          fillRule="evenodd"
          d="M4.5 1.5v21L21 12 4.5 1.5Z"
          clipRule="evenodd"
        />
      )}
    </svg>
  );
}
